import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import editIcon from "../../../assets/images/Edit.svg";
import viewIcon from "../../../assets/images/View.svg";
import { ROLES } from "../../../config/Roles.config";
import { MuiDataGridStyle } from "../../../theme/App.theme";
import NoRecordsToDisplay from "../../../components/CommonReusableComponent/NoRecordsToDisplay/NoRecordsToDisplay";
import { getUserRoleAndScreens } from "../../../services/authServices/auth.services";
import { thirdPartyStatusConfigData } from "../../../config/AuditStatusConfig";
import { RemarkText, ThirdPartyAuditStatusPill } from "./ThirdPartyAuditMaster.config";

const ThirdPartyAuditMasterDataTable_V2 = ({
  Rows,
  GetRowDataOnClickOfAction,
  PageSizeOptions,
  RowsToDisplay,
}) => {
  const { role, userUid } = getUserRoleAndScreens();
  const { draftAudits, reviewPending } = thirdPartyStatusConfigData;

  // -------- Conditions to show edit button ---------
  // const getAuditee = (ID) => {
  //   return getLoggedInUserIsAuditeeOrAuditor(ROLES.AUDITEE, ID).isAuditee;
  // };

  // const getAuditor = (ID) => {
  //   return getLoggedInUserIsAuditeeOrAuditor(ROLES.AUDITOR, ID).isAuditor;
  // };

  // const isSuperAdmin =
  //   role && role.toLowerCase() === ROLES.SUPERADMIN ? true : false;

  // const isAdmin = role && role.toLowerCase() === ROLES.ADMIN ? true : false;

  const isUser = role && role.toLowerCase() === ROLES.USER ? true : false;

  const isAbleToEdit = (audit_data) => {
    const permissionForUser =
      isUser &&
      audit_data?.status === draftAudits &&
      userUid === audit_data?.createdBy;
  
    const permissionForSuperAdminOrAdmin = 
      !isUser && audit_data?.status === reviewPending

    return permissionForUser || permissionForSuperAdminOrAdmin;
  };

  // Data Table columns
  const Columns = [
    {
      field: "action",
      headerName: "Action",
      filterable: false,
      sortable: false,
      headerAlign: 'center',
      disableColumnMenu: true,
      minWidth: 90,
      maxWidth: 90,
      renderCell: (param) => (
        <div className="d-flex gap-3 align-items-center h-100">
          <img
            src={viewIcon}
            className="cursor-pointer"
            alt={"View"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction(
                "View Audit",
                param?.row,
                "/third-party-audit-master/view"
              );
            }}
          />
          <img
            src={editIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{
              width: "20px",
              height: "20px",
              display: isAbleToEdit(param?.row) ? 'initial' : 'none'
            }}
            onClick={() => {
              GetRowDataOnClickOfAction(
                "Update Audit",
                param?.row,
                "/third-party-audit-master/update"
              );
            }}
          />
        </div>
      ),
    },
    {
      field: "auditTypeCategoryName",
      headerName: "Audit Type Category",
      sortable: false,
      flex: 1,
      minWidth: 170,
    },
    {
      field: "auditTypeName",
      headerName: "Audit Type",
      sortable: false,
      flex: 1,
      minWidth: 170,
    },
    {
      field: "departmentName",
      headerName: "Department",
      sortable: false,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 1,
      minWidth: 100,
      maxWidth: 130,
      renderCell: (param) => <ThirdPartyAuditStatusPill data={param?.value} />
    },
    {
      field: "remark",
      headerName: "Remark",
      sortable: false,
      flex: 1,
      minWidth: 100,
      maxWidth: 130,
      renderCell: (param) => <RemarkText data={param?.value} tooltipRequired />
    },
    {
      field: "totalActivitiesCount",
      headerName: "Total Activities",
      sortable: false,
      flex: 1,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: "totalNCActivitiesCount",
      headerName: "Total NC's",
      sortable: false,
      flex: 1,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: "closedActivitiesCount",
      headerName: "Closed NC's",
      sortable: false,
      flex: 1,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: "startAndEndDate",
      headerName: "Start and End Date",
      sortable: false,
      flex: 1,
      minWidth: 180,
    },
  ];

  return (
    <React.Fragment>
      <div className="w-100">
        <DataGrid
          columns={Columns}
          rows={Rows}
          slots={{
            noRowsOverlay: NoRecordsToDisplay,
          }}
          pageSizeOptions={PageSizeOptions || [5, 10, 15, 25, 50]}
          initialState={{
            density: "compact",
            pagination: {
              paginationModel: {
                pageSize: RowsToDisplay || 10,
              },
            },
          }}
          disableRowSelectionOnClick
          density="compact"
          className="custom-data-grid"
          sx={MuiDataGridStyle}
        />
      </div>
    </React.Fragment>
  );
};

export default ThirdPartyAuditMasterDataTable_V2;
